import React from 'react';
import {Button} from "react-bootstrap";

const Row = ({ affid, subid, country, cutoff, updateFactor }) => {

    return (
        <tr>
            <td>{affid}</td>
            <td>{subid}</td>
            <td>{country}</td>
            <td>{cutoff}</td>
            <td style={{ width: '1%', whiteSpace: 'nowrap' }}>
                <Button bsStyle={'primary'} onClick={() => updateFactor(affid, subid, country)}>
                    Edit Cutoff
                </Button>
            </td>
        </tr>
    );
};

export default Row;



// WEBPACK FOOTER //
// ./src/scenes/DummyCutoffAll/components/Table/components/Row/index.js